import { QueryClient } from '@tanstack/react-query'

/**
 * The QueryClient the portal runs with, standalone (`main.tsx`) and federated (`RelayModule.tsx`).
 *
 * One factory because the two entry points each built their own with the same defaults written out
 * twice, and a change to one (a longer stale time, a different retry) would silently leave the
 * other behind. The defaults:
 * - `staleTime: 30_000`: a list visited twice in half a minute is not fetched twice;
 * - `retry: 1`: one retry absorbs a dropped connection without making a real failure wait through
 *   React Query's default three.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
  })
}
